import * as React from 'react'
import { ColAuto } from '@hyper/col-auto'
import { Button, FormGroup, Row } from 'reactstrap'
import { FormProvider, useForm } from 'react-hook-form'
import { SearchFilter } from '@modules/reception/common/filters/search-filter'
import { useHandleTableFiltersChange } from '@components/table/use-handle-table-filters-change'
import { AccountUserListTableFilters } from '@modules/account/users/list/index'
import { useAppSelector } from '@store/index'
import { groupsSelector } from '@store/slices/account-slice'
import { FormSelect } from '@hyper/forms/form-select'
import { YesNoOptions } from '@helpers/consts'

interface Props {
  defaultFilters: AccountUserListTableFilters
  filters: AccountUserListTableFilters
  setFilters: (filters: AccountUserListTableFilters) => void
}

export const AccountUsersListFilter: React.FC<Props> = ({ defaultFilters, filters, setFilters }) => {
  const methods = useForm<AccountUserListTableFilters>({
    defaultValues: defaultFilters,
  })

  const groupOptions = useAppSelector(groupsSelector).map(row => ({ label: row.name, value: row.id }))

  const handleReset = () => {
    methods.reset()
    setFilters(defaultFilters)
  }

  const onSubmit = async (payload: AccountUserListTableFilters) => setFilters({ ...filters, ...payload })

  useHandleTableFiltersChange(methods.watch, filters, onSubmit)

  return (
    <FormProvider {...methods}>
      <Row>
        <ColAuto className="px-0">
          <FormSelect
            options={YesNoOptions}
            name="is_worker"
            label="Pracownik?"
            selectProps={{ isClearable: true }}
            formPlainProps={{ colStyle: { width: 200 } }}
          />
        </ColAuto>
        <ColAuto className="px-0">
          <FormSelect
            options={YesNoOptions}
            name="is_staff"
            label="Dostęp do panelu"
            selectProps={{ isClearable: true }}
            formPlainProps={{ colStyle: { width: 200 } }}
          />
        </ColAuto>
        <ColAuto className="px-0">
          <FormSelect
            options={YesNoOptions}
            name="is_receptionist"
            label="Recepcjonista?"
            selectProps={{ isClearable: true }}
            formPlainProps={{ colStyle: { width: 200 } }}
          />
        </ColAuto>
        <ColAuto className="px-0">
          <FormSelect
            options={YesNoOptions}
            name="is_resort_manager"
            label="Dyrektor ośrodka"
            selectProps={{ isClearable: true }}
            formPlainProps={{ colStyle: { width: 200 } }}
          />
        </ColAuto>
        <ColAuto className="px-0">
          <FormSelect
            options={YesNoOptions}
            name="is_superuser"
            label="Administrator?"
            selectProps={{ isClearable: true }}
            formPlainProps={{ colStyle: { width: 200 } }}
          />
        </ColAuto>
        <ColAuto className="px-0">
          <FormSelect
            options={YesNoOptions}
            name="is_active"
            label="Aktywny?"
            selectProps={{ isClearable: true }}
            formPlainProps={{ colStyle: { width: 200 } }}
          />
        </ColAuto>
      </Row>
      <Row>
        <ColAuto className="px-0">
          <FormSelect
            options={groupOptions}
            name="groups"
            label="Grupy"
            selectProps={{ isClearable: true, isSelectMulti: true }}
            formPlainProps={{ colStyle: { width: 400 } }}
          />
        </ColAuto>
        <ColAuto>
          <FormGroup>
            <label className="d-block">&nbsp;</label>
            <Button color="primary">Filtruj</Button>
            {methods.formState.isDirty && (
              <Button color="light" className="ml-1" type="button" onClick={handleReset}>
                Wyczyść
              </Button>
            )}
          </FormGroup>
        </ColAuto>
        <SearchFilter colClassName="col-md-2" />
      </Row>
    </FormProvider>
  )
}
